import React, { type JSX } from 'react';

import Box from '../Box';

import { FlexCommonProps } from './Flex.common';

export type Props = React.ComponentProps<typeof Box> & FlexCommonProps;

function Flex({ htmlRef, ref, ...props }: Props): JSX.Element {
  // React 19: pull `ref` out of props so a styled(Flex)-injected ref can't clobber htmlRef.
  return <Box display="flex" {...props} ref={htmlRef ?? ref} />;
}

/**
 * Flex is a layout component that applies flexbox display.
 * It's a specialized Box with display="flex" and gap support.
 *
 * READ THE DOCS: https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/5210898784/Kibble+Core+Flex
 */
export default Flex;
